module.exports = __webpack_public_path__ + "static/images/styles/images/divider-dots-horizontal.f6a27a67.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/divider-dots-horizontal.png
// module id = 3618
// module chunks = 11